import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  savedProgramSetWrapper: {},

  savedProgramSetBottom: {
    marginTop: 8,
  },
}));
